export const PageLink = {
  En: '/',
  Ja: '/ja',
  Kor: '/kor',
  Chn: '/chn',
};
